export const TABS_LOCALE_ZHCHS = {
    more: 'æ´å¤',
};
